"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9518],{

/***/ 8009:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CD": function() { return /* binding */ EXPIRED_GUIDE_MODE; },
/* harmony export */   "Sf": function() { return /* binding */ EXPIRED_GUIDE_SEVERE_EXCLUDED_PATHS; },
/* harmony export */   "UU": function() { return /* binding */ EXPIRED_PURCHASE_PATH; },
/* harmony export */   "h7": function() { return /* binding */ EXPIRED_GUIDE_DETAIL_EXCLUDED_PATHS; },
/* harmony export */   "jp": function() { return /* binding */ resolveDashboardPathByMode; }
/* harmony export */ });
/* unused harmony export EXPIRED_GUIDE_DASHBOARD_PATHS */
const EXPIRED_GUIDE_MODE = {
    NONE: "none",
    GRACE: "grace",
    SEVERE: "severe"
};
/** 全部设备过期超 30 天且无有效未绑单时的独立续费页（禁止进设备 dashboard） */ const EXPIRED_PURCHASE_PATH = "/expired-purchase";
/** 详情页不展示宽限期遮罩的路径 */ const EXPIRED_GUIDE_DETAIL_EXCLUDED_PATHS = [
    "/dashboard",
    "/android/dashboard",
    "/android/local/dashboard",
    "/pages/account-settings/account",
    "/android/local/permission-check",
    "/setup",
    "/android/classification",
    "/android/local/setup",
    "/android/setup",
    "/android/nodevice-setup",
    "/ios/setup",
    "/ios/extreme-verification",
    "/guide",
    "/settings",
    "/expired-purchase"
];
/** 全屏严重过期引导也不展示的路径（引导/设置流程） */ const EXPIRED_GUIDE_SEVERE_EXCLUDED_PATHS = [
    "/setup",
    "/android/classification",
    "/android/local/setup",
    "/android/setup",
    "/android/nodevice-setup",
    "/ios/setup",
    "/ios/extreme-verification",
    "/guide",
    "/settings"
];
const EXPIRED_GUIDE_DASHBOARD_PATHS = (/* unused pure expression or super */ null && ([
    "/dashboard",
    "/android/dashboard",
    "/android/local/dashboard"
]));
const resolveDashboardPathByMode = (mode)=>{
    if (mode === "Android-Cloud") return "/android/dashboard";
    if (mode === "Android-Local") return "/android/local/dashboard";
    return "/dashboard";
};


/***/ }),

/***/ 99518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ey": function() { return /* binding */ redirectToChooseDevice; },
/* harmony export */   "fs": function() { return /* binding */ redirectGuideAddNewDevice; },
/* harmony export */   "og": function() { return /* binding */ redirectIfShouldBuyPackage; },
/* harmony export */   "tA": function() { return /* binding */ filterValidUnboundOrders; }
/* harmony export */ });
/* unused harmony export shouldRedirectToBuyPackage */
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var src_utils_navigate__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48551);
/* harmony import */ var src_components_expired_purchase_guide_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8009);
/* harmony import */ var src_utils_userEntryGate__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1128);




/** 与 web `appBridge` 桥接参数对齐（App 跳转购买时透传） */ const BRIDGE_QUERY_KEYS = [
    "from_app",
    "app_platform",
    "anonymous_user_id",
    "app_session_id",
    "web_bridge_id",
    "source_screen",
    "cta_name",
    "feature_id",
    "feature_name",
    "installid",
    "idfa",
    "ver",
    "agent"
];
/** 未过期、可绑定的未绑单（与跳转选购页判定一致） */ const filterValidUnboundOrders = (list)=>{
    const orders = Array.isArray(list) ? list : [];
    const now = Date.now();
    return orders.filter((item)=>{
        const expireTime = (item === null || item === void 0 ? void 0 : item.expire_time) ? new Date(item.expire_time).getTime() : 0;
        return Number.isFinite(expireTime) && expireTime >= now;
    });
};
/** 无有效未绑定订单（空列表或全部过期） */ const shouldRedirectToBuyPackage = (list)=>filterValidUnboundOrders(list).length === 0;
const isFromAppClient = ()=>{
    if (false) {}
    try {
        if (new URLSearchParams(window.location.search).get("from_app") === "1") return true;
        if (localStorage.getItem("installid")) return true;
        const bridge = JSON.parse(sessionStorage.getItem("spyx_web_app_bridge") || "null");
        if ((bridge === null || bridge === void 0 ? void 0 : bridge.from_app) === "1") return true;
    } catch (e) {
    // ignore
    }
    return false;
};
const buildClientBuyPath = ()=>{
    const token = localStorage.getItem("accessToken");
    const fromApp = isFromAppClient();
    const params = new URLSearchParams();
    if (token) params.set("token", token);
    // Msafely web 未迁 SpyX 的 /step/*；对齐 dashboard main 的官网路径
    if (fromApp) {
        params.set("from_app", "1");
        try {
            const current = new URLSearchParams(window.location.search);
            BRIDGE_QUERY_KEYS.forEach((key)=>{
                const value = current.get(key);
                if (value) params.set(key, value);
            });
        } catch (e) {
        // ignore
        }
        const qs = params.toString();
        const pricingPath = "/pricing" || 0;
        return "".concat(pricingPath).concat(qs ? "?".concat(qs) : "");
    }
    const qs1 = params.toString();
    return "/choose-monitored-device".concat(qs1 ? "?".concat(qs1) : "");
};
/** 去购买：对齐 Msafely main → /choose-monitored-device；App → /pricing */ const redirectToChooseDevice = ()=>{
    const clientUrl = "https://msafely.com" || 0;
    (0,src_utils_navigate__WEBPACK_IMPORTED_MODULE_1__/* .navigateTo */ .T8)("".concat(clientUrl).concat(buildClientBuyPath()));
};
/**
 * Guide 顶栏「Add New Device」：
 * 已有套餐（已绑设备或有效未绑单）→ Dashboard；否则 → 官网 /choose-monitored-device
 */ const redirectGuideAddNewDevice = async ()=>{
    try {
        const { getAllUserDevice , getNotBindOrder  } = await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 53399));
        const [devicesRes, ordersRes] = await Promise.all([
            getAllUserDevice({}).catch(()=>({
                    data: []
                })),
            getNotBindOrder({}).catch(()=>({
                    data: []
                }))
        ]);
        const devices = Array.isArray(devicesRes === null || devicesRes === void 0 ? void 0 : devicesRes.data) ? devicesRes.data : [];
        const hasValidUnboundOrders = filterValidUnboundOrders(ordersRes === null || ordersRes === void 0 ? void 0 : ordersRes.data).length > 0;
        if (devices.length > 0 || hasValidUnboundOrders) {
            next_router__WEBPACK_IMPORTED_MODULE_0___default().push("/dashboard");
            return;
        }
    } catch (error) {
        ;
    }
    redirectToChooseDevice();
};
/**
 * setup 类页面的兜底：没有有效未绑单时离开绑定流程。
 * 优先级由 userEntryGate 统一裁决：全部订单过期超 30 天 → 过期页，其余 → 去购买。
 * 已有有效未绑单则原地留在绑定流程。
 * @returns {Promise<boolean>} 是否已发生跳转
 */ const redirectIfShouldBuyPackage = async (orderResult)=>{
    const list = (orderResult === null || orderResult === void 0 ? void 0 : orderResult.data) || [];
    const validUnbound = filterValidUnboundOrders(list);
    if (validUnbound.length > 0) return false;
    const flags = await (0,src_utils_userEntryGate__WEBPACK_IMPORTED_MODULE_3__/* .loadUserEntryFlags */ .lf)();
    const entryType = (0,src_utils_userEntryGate__WEBPACK_IMPORTED_MODULE_3__/* .resolveUserEntry */ .Ji)({
        flags,
        validUnboundOrders: validUnbound
    });
    if (entryType === src_utils_userEntryGate__WEBPACK_IMPORTED_MODULE_3__/* .USER_ENTRY.EXPIRED */ .Tv.EXPIRED) {
        window.location.assign(src_components_expired_purchase_guide_constants__WEBPACK_IMPORTED_MODULE_2__/* .EXPIRED_PURCHASE_PATH */ .UU);
        return true;
    }
    redirectToChooseDevice();
    return true;
};


/***/ }),

/***/ 96613:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EI": function() { return /* binding */ parseExpireMs; },
/* harmony export */   "Jn": function() { return /* binding */ THIRTY_DAYS_MS; },
/* harmony export */   "ku": function() { return /* binding */ resolveDeviceExpireTime; },
/* harmony export */   "l": function() { return /* binding */ buildDeviceUserPayload; }
/* harmony export */ });
/* unused harmony exports isSubscriptionActive, isDeviceActive, isExpiredPastGracePeriod, areAllDevicesExpiredPastGrace, isDeviceWithinGracePeriod, shouldShowExpiredMask, pickFirstActiveDevice */
/**
 * 解析 expire_time 为 UTC 毫秒时间戳。
 * ISO 8601 带 Z（如 2026-11-16T07:35:07.623Z）会被正确解析为绝对时刻，与用户本地时区无关。
 */ const parseExpireMs = (raw)=>{
    if (raw == null || raw === "") return NaN;
    const ms = new Date(raw).getTime();
    return Number.isFinite(ms) ? ms : NaN;
};
/** 订阅仍有效：无 expire_time 视为有效；否则 expire_time >= 当前时刻 */ const isSubscriptionActive = function(expireTime) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now();
    const ms = parseExpireMs(expireTime);
    if (!Number.isFinite(ms)) return true;
    return ms >= now;
};
const isDeviceActive = (device)=>{
    return isSubscriptionActive(device === null || device === void 0 ? void 0 : device.expire_time);
};
const THIRTY_DAYS_MS = 30 * 24 * 60 * 60 * 1000;
/** 已过期且超过宽限期（默认 30 天） */ const isExpiredPastGracePeriod = function(expireTime) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : THIRTY_DAYS_MS;
    const ms = parseExpireMs(expireTime);
    if (!Number.isFinite(ms)) return false;
    if (ms >= now) return false;
    return now - ms > graceMs;
};
/** 全部设备均已过期且超过宽限期 */ const areAllDevicesExpiredPastGrace = function(devices) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : THIRTY_DAYS_MS;
    const list = Array.isArray(devices) ? devices : [];
    if (!list.length) return false;
    return list.every((device)=>{
        return isExpiredPastGracePeriod(device === null || device === void 0 ? void 0 : device.expire_time, now, graceMs);
    });
};
/** 从侧栏设备项（数组或单条记录）解析 expire_time */ const resolveDeviceExpireTime = (item)=>{
    var ref, ref1, ref2;
    if (!item) return null;
    if (item.expire_time != null && item.expire_time !== "") return item.expire_time;
    if (Array.isArray(item) && ((ref = item[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.DeviceUser) === null || ref1 === void 0 ? void 0 : ref1.expire_time)) return item[0].DeviceUser.expire_time;
    if (item === null || item === void 0 ? void 0 : (ref2 = item.DeviceUser) === null || ref2 === void 0 ? void 0 : ref2.expire_time) return item.DeviceUser.expire_time;
    return null;
};
/** 侧栏仍展示：未过期、无 expire_time、或过期未超过 graceDays（默认 30 天） */ const isDeviceWithinGracePeriod = function(expireTime) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : THIRTY_DAYS_MS;
    const ms = parseExpireMs(expireTime);
    if (!Number.isFinite(ms)) return true;
    if (ms >= now) return true;
    return now - ms <= graceMs;
};
/** Feature 详情页遮罩：已过期且在宽限期内（默认 30 天） */ const shouldShowExpiredMask = function(expireTime) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : THIRTY_DAYS_MS;
    return !isSubscriptionActive(expireTime, now) && isDeviceWithinGracePeriod(expireTime, now, graceMs);
};
/** 取第一个可选中设备：优先未过期(active)，其次宽限期(grace)；永不返回超 30 天失效 */ const pickFirstActiveDevice = (devices, platformType)=>{
    const list = Array.isArray(devices) ? devices : [];
    const scoped = platformType ? list.filter((item)=>{
        return (item === null || item === void 0 ? void 0 : item.platform_type) === platformType;
    }) : list;
    const now = Date.now();
    const selectable = scoped.filter((item)=>{
        const ms = parseExpireMs(item === null || item === void 0 ? void 0 : item.expire_time);
        if (!Number.isFinite(ms)) return true;
        if (ms >= now) return true;
        return now - ms <= THIRTY_DAYS_MS;
    });
    if (!selectable.length) return null;
    return selectable.find(isDeviceActive) || selectable[0] || null;
};
var ref, ref1, ref2;
const buildDeviceUserPayload = (device)=>{
    return {
        username: device.iCloud_username,
        password: device.iCloud_password,
        temporary: device.temporary,
        expire_time: device.expire_time,
        likeType: device.like_type,
        device_id: (device === null || device === void 0 ? void 0 : device.id) || (device === null || device === void 0 ? void 0 : device.device_id) || "",
        order_id: (ref1 = (ref = device === null || device === void 0 ? void 0 : device.order_id) !== null && ref !== void 0 ? ref : device === null || device === void 0 ? void 0 : device.orderId) !== null && ref1 !== void 0 ? ref1 : null,
        subscription_status: (ref2 = device === null || device === void 0 ? void 0 : device.subscription_status) !== null && ref2 !== void 0 ? ref2 : null
    };
};


/***/ }),

/***/ 38365:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "He": function() { return /* binding */ isSelectableDevice; },
/* harmony export */   "MA": function() { return /* binding */ resolveDeviceSubscriptionStatus; },
/* harmony export */   "Mi": function() { return /* binding */ resolveInitialEntry; },
/* harmony export */   "Xz": function() { return /* binding */ getDeviceNotSelectableMessage; },
/* harmony export */   "dv": function() { return /* binding */ validateDeviceSelection; },
/* harmony export */   "mJ": function() { return /* binding */ isDeviceVisibleInSidebar; },
/* harmony export */   "oT": function() { return /* binding */ pickPreferredSelectableDevice; },
/* harmony export */   "q6": function() { return /* binding */ shouldEnterExpiredPurchasePage; },
/* harmony export */   "qq": function() { return /* binding */ SUBSCRIPTION_STATUS; },
/* harmony export */   "w4": function() { return /* binding */ resolveDeviceOrderId; }
/* harmony export */ });
/* unused harmony exports normalizeSubscriptionStatus, resolveSubscriptionStatus, isSelectableSubscriptionStatus, isLapsedDevice, isGraceDevice, isNoneDevice, areAllDevicesLapsed, areAllDevicesNonSelectable */
/* harmony import */ var src_utils_subscriptionExpire__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96613);

/** 设备订阅状态机（与后端 user-device.subscription_status 对齐） */ const SUBSCRIPTION_STATUS = Object.freeze({
    /** 未过期 */ ACTIVE: "active",
    /** 已过期且 ≤30 天（含第 30 天，宽限期，仍可选中） */ GRACE: "grace",
    /** 已过期且 >30 天（失效，禁止选中） */ LAPSED: "lapsed",
    /**
   * 特殊态：无已支付订单，或 expire_time 为空/异常。
   * ≠ lapsed：不进「全员超 30 天」独立续费页；也不可选中。
   */ NONE: "none"
});
const STATUS_SET = new Set(Object.values(SUBSCRIPTION_STATUS));
const normalizeSubscriptionStatus = (raw)=>{
    if (raw == null || raw === "") return null;
    const status = String(raw).toLowerCase();
    return STATUS_SET.has(status) ? status : null;
};
/**
 * 由 expire_time 本地兜底（接口未回 subscription_status 时用）。
 * 无有效 expire_time → active（兼容历史无到期字段仍可进 dashboard）。
 * 服务端显式 none 时走 subscription_status 字段，不走本函数。
 */ const resolveSubscriptionStatus = function(expireTime) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : src_utils_subscriptionExpire__WEBPACK_IMPORTED_MODULE_0__/* .THIRTY_DAYS_MS */ .Jn;
    const ms = (0,src_utils_subscriptionExpire__WEBPACK_IMPORTED_MODULE_0__/* .parseExpireMs */ .EI)(expireTime);
    if (!Number.isFinite(ms)) return SUBSCRIPTION_STATUS.ACTIVE;
    if (ms >= now) return SUBSCRIPTION_STATUS.ACTIVE;
    if (now - ms <= graceMs) return SUBSCRIPTION_STATUS.GRACE;
    return SUBSCRIPTION_STATUS.LAPSED;
};
/**
 * 优先用设备/DeviceUser 上的 subscription_status；否则用 expire_time 兜底。
 */ const resolveDeviceSubscriptionStatus = function(device) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : src_utils_subscriptionExpire__WEBPACK_IMPORTED_MODULE_0__/* .THIRTY_DAYS_MS */ .Jn;
    const fromApi = normalizeSubscriptionStatus(device === null || device === void 0 ? void 0 : device.subscription_status);
    if (fromApi) return fromApi;
    var ref;
    return resolveSubscriptionStatus((ref = (0,src_utils_subscriptionExpire__WEBPACK_IMPORTED_MODULE_0__/* .resolveDeviceExpireTime */ .ku)(device)) !== null && ref !== void 0 ? ref : device === null || device === void 0 ? void 0 : device.expire_time, now, graceMs);
};
/** active / grace 可选中；lapsed / none 禁止成为当前选中 */ const isSelectableSubscriptionStatus = (status)=>status === SUBSCRIPTION_STATUS.ACTIVE || status === SUBSCRIPTION_STATUS.GRACE;
const isSelectableDevice = function(device) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : src_utils_subscriptionExpire__WEBPACK_IMPORTED_MODULE_0__/* .THIRTY_DAYS_MS */ .Jn;
    if (!device) return false;
    return isSelectableSubscriptionStatus(resolveDeviceSubscriptionStatus(device, now, graceMs));
};
const isLapsedDevice = function(device) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : src_utils_subscriptionExpire__WEBPACK_IMPORTED_MODULE_0__/* .THIRTY_DAYS_MS */ .Jn;
    return resolveDeviceSubscriptionStatus(device, now, graceMs) === SUBSCRIPTION_STATUS.LAPSED;
};
const isGraceDevice = function(device) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : THIRTY_DAYS_MS;
    return resolveDeviceSubscriptionStatus(device, now, graceMs) === SUBSCRIPTION_STATUS.GRACE;
};
const isNoneDevice = function(device) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : THIRTY_DAYS_MS;
    return resolveDeviceSubscriptionStatus(device, now, graceMs) === SUBSCRIPTION_STATUS.NONE;
};
/**
 * 侧栏设备卡片是否展示：
 * - active / grace：展示
 * - none：展示（特殊：无有效已付单，但仍是绑定记录）
 * - lapsed：隐藏
 */ const isDeviceVisibleInSidebar = function(device) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : src_utils_subscriptionExpire__WEBPACK_IMPORTED_MODULE_0__/* .THIRTY_DAYS_MS */ .Jn;
    if (!device) return false;
    return resolveDeviceSubscriptionStatus(device, now, graceMs) !== SUBSCRIPTION_STATUS.LAPSED;
};
/**
 * 设备关联已支付订单 ID（后端 user-device.order_id）。
 * @returns {string|number|null}
 */ const resolveDeviceOrderId = (device)=>{
    var ref, ref1;
    if (!device) return null;
    var _order_id, ref2, ref3;
    const id = (ref3 = (ref2 = (_order_id = device.order_id) !== null && _order_id !== void 0 ? _order_id : device.orderId) !== null && ref2 !== void 0 ? ref2 : device === null || device === void 0 ? void 0 : (ref = device.Order) === null || ref === void 0 ? void 0 : ref.id) !== null && ref3 !== void 0 ? ref3 : device === null || device === void 0 ? void 0 : (ref1 = device.order) === null || ref1 === void 0 ? void 0 : ref1.id;
    if (id == null || id === "") return null;
    return id;
};
/**
 * 初始化/恢复选中：优先 active，其次 grace；永不返回 lapsed/none。
 * @param {Array} devices
 * @param {string} [platformType]
 */ const pickPreferredSelectableDevice = (devices, platformType)=>{
    const list = Array.isArray(devices) ? devices : [];
    const scoped = platformType ? list.filter((item)=>{
        return (item === null || item === void 0 ? void 0 : item.platform_type) === platformType;
    }) : list;
    const selectable = scoped.filter((item)=>isSelectableDevice(item));
    if (!selectable.length) return null;
    const active = selectable.find((item)=>resolveDeviceSubscriptionStatus(item) === SUBSCRIPTION_STATUS.ACTIVE);
    return active || selectable[0] || null;
};
/**
 * 选中校验：仅 active/grace 可选。
 * @returns {{ ok: boolean, status: string, reason?: string }}
 */ const validateDeviceSelection = function(device) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now();
    if (!device || typeof device === "object" && !Object.keys(device).length) {
        return {
            ok: true,
            status: SUBSCRIPTION_STATUS.NONE
        };
    }
    const status = resolveDeviceSubscriptionStatus(device, now);
    if (!isSelectableSubscriptionStatus(status)) {
        return {
            ok: false,
            status,
            reason: status === SUBSCRIPTION_STATUS.LAPSED ? "lapsed_device_not_selectable" : "device_not_selectable"
        };
    }
    return {
        ok: true,
        status
    };
};
/** 侧栏不可选设备的英文提示（none ≠ 过期） */ const getDeviceNotSelectableMessage = function(device) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now();
    const status = resolveDeviceSubscriptionStatus(device, now);
    if (status === SUBSCRIPTION_STATUS.NONE) {
        return "This package has no active subscription and cannot be selected.";
    }
    if (status === SUBSCRIPTION_STATUS.LAPSED) {
        return "This package subscription has expired and cannot be selected.";
    }
    return "This package cannot be selected.";
};
/**
 * 是否「全部设备都是 lapsed」。
 * none 不算 lapsed（有 none 混在时为 false）。
 * 只信 subscription_status（无字段时才 expire_time 兜底）。
 */ const areAllDevicesLapsed = function(devices) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : src_utils_subscriptionExpire__WEBPACK_IMPORTED_MODULE_0__/* .THIRTY_DAYS_MS */ .Jn;
    const list = Array.isArray(devices) ? devices : [];
    if (!list.length) return false;
    return list.every((device)=>isLapsedDevice(device, now, graceMs));
};
/** 无任何可选中设备（全是 lapsed / none） */ const areAllDevicesNonSelectable = function(devices) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : THIRTY_DAYS_MS;
    const list = Array.isArray(devices) ? devices : [];
    if (!list.length) return false;
    return list.every((device)=>!isSelectableDevice(device, now, graceMs));
};
/**
 * 独立续费页入口（替换旧「全设备过期超 30 天 + 无未绑单」本地推算）：
 * - 设备非空且全部 subscription_status === lapsed
 * - 且 not-bind-order 无有效未绑单
 *
 * none 不进此页。
 */ const shouldEnterExpiredPurchasePage = function() {
    let { devices =[] , validUnboundOrders =[]  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const list = Array.isArray(devices) ? devices : [];
    const unbound = Array.isArray(validUnboundOrders) ? validUnboundOrders : [];
    return list.length > 0 && areAllDevicesLapsed(list) && unbound.length === 0;
};
/**
 * 登录/进站：active/grace 设备 > 未绑单 > 空态
 * 「全部过期超 30 天」的判定由 userEntryGate 负责（后端状态优先），这里不参与。
 * 永不选中 lapsed/none。
 * @returns {{ type: 'device'|'unbound'|'empty', device: object|null }}
 */ const resolveInitialEntry = function() {
    let { devices =[] , validUnboundOrders =[] , preferredMode =null , preferredDevice =null  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const list = Array.isArray(devices) ? devices : [];
    const unbound = Array.isArray(validUnboundOrders) ? validUnboundOrders : [];
    if (preferredDevice && isSelectableDevice(preferredDevice)) {
        return {
            type: "device",
            device: preferredDevice
        };
    }
    const preferred = pickPreferredSelectableDevice(list, preferredMode) || pickPreferredSelectableDevice(list);
    if (preferred) {
        return {
            type: "device",
            device: preferred
        };
    }
    if (unbound.length > 0) {
        return {
            type: "unbound",
            device: null
        };
    }
    return {
        type: "empty",
        device: null
    };
};


/***/ }),

/***/ 1128:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ji": function() { return /* binding */ resolveUserEntry; },
/* harmony export */   "Tv": function() { return /* binding */ USER_ENTRY; },
/* harmony export */   "lf": function() { return /* binding */ loadUserEntryFlags; }
/* harmony export */ });
/* unused harmony exports readUserEntryFlags, clearUserEntryFlags */
/* harmony import */ var src_api_login__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53399);
/* harmony import */ var src_utils_subscriptionStatus__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38365);


/**
 * 进站入口判定。
 *
 * 后端 `user-device` 只返回「未过期，或过期不超过 30 天」的设备包，
 * 因此设备列表为空既可能是从没买过，也可能是所有包都过期超 30 天，
 * 前端无法再用「设备全部 lapsed」推断该不该进过期页。
 * 这里改为以后端状态为准，本地推算只作为接口不可用时的降级。
 *
 * 优先级固定：
 * 1. isBuy === false                    → 购买
 * 2. isBuy === true 且 valid === false  → 过期超 30 天页
 * 3. 其余                               → 设备 / 未绑单 / 绑定向导流程
 */ const USER_ENTRY = Object.freeze({
    BUY: "buy",
    EXPIRED: "expired",
    CONTINUE: "continue"
});
const readBoolean = (value)=>typeof value === "boolean" ? value : null;
let flagsCache = null;
let flagsLoading = null;
/**
 * 读取 isBuy / shouldShowExpiredPage。
 * - isBuy：是否付过费（存在已支付订单，或存在设备记录）
 * - shouldShowExpiredPage：由 /tsafely-order/valid 的 valid 取反，表示最新一笔已支付订单已过期超 30 天
 *
 * 任一请求失败时对应字段为 null，调用方回退到本地推算，
 * 避免把接口异常当成「没买过」而把老用户踢去购买页。
 * @returns {Promise<{ isBuy: boolean|null, shouldShowExpiredPage: boolean|null }>}
 */ const loadUserEntryFlags = async function() {
    let { forceRefresh =false  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!forceRefresh && flagsCache) return flagsCache;
    if (flagsLoading) return flagsLoading;
    flagsLoading = Promise.all([
        (0,src_api_login__WEBPACK_IMPORTED_MODULE_0__.getUserIsBuy)().catch(()=>null),
        (0,src_api_login__WEBPACK_IMPORTED_MODULE_0__.getUserHasValidOrder)().catch(()=>null)
    ]).then((param)=>{
        let [buyRes, validRes] = param;
        var ref, ref1;
        const hasValidOrder = readBoolean(validRes === null || validRes === void 0 ? void 0 : (ref = validRes.data) === null || ref === void 0 ? void 0 : ref.valid);
        flagsCache = {
            isBuy: readBoolean(buyRes === null || buyRes === void 0 ? void 0 : (ref1 = buyRes.data) === null || ref1 === void 0 ? void 0 : ref1.isBuy),
            shouldShowExpiredPage: hasValidOrder === null ? null : !hasValidOrder
        };
        return flagsCache;
    }).finally(()=>{
        flagsLoading = null;
    });
    return flagsLoading;
};
const readUserEntryFlags = ()=>flagsCache;
const clearUserEntryFlags = ()=>{
    flagsCache = null;
};
/**
 * 按固定优先级给出入口结论；后端状态拿不到时才用 devices / 未绑单本地推算。
 * @param {Object} params
 * @param {{ isBuy: boolean|null, shouldShowExpiredPage: boolean|null }} [params.flags]
 * @param {Array} [params.devices]
 * @param {Array} [params.validUnboundOrders]
 * @returns {'buy'|'expired'|'continue'}
 */ const resolveUserEntry = function() {
    let { flags , devices =[] , validUnboundOrders =[]  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var ref;
    const isBuy = (ref = flags === null || flags === void 0 ? void 0 : flags.isBuy) !== null && ref !== void 0 ? ref : null;
    var ref1;
    const shouldShowExpiredPage = (ref1 = flags === null || flags === void 0 ? void 0 : flags.shouldShowExpiredPage) !== null && ref1 !== void 0 ? ref1 : null;
    if (isBuy === false) return USER_ENTRY.BUY;
    if (isBuy === true && shouldShowExpiredPage === true) return USER_ENTRY.EXPIRED;
    // 降级：接口未返回或请求失败时，沿用本地「设备全部 lapsed 且无未绑单」的推算
    if (isBuy === null || shouldShowExpiredPage === null) {
        if ((0,src_utils_subscriptionStatus__WEBPACK_IMPORTED_MODULE_1__/* .shouldEnterExpiredPurchasePage */ .q6)({
            devices,
            validUnboundOrders
        })) return USER_ENTRY.EXPIRED;
    }
    return USER_ENTRY.CONTINUE;
};


/***/ })

}]);